<template>
  <v-container fluid>
    <v-tabs fixed-tabs v-model="department">
      <v-tab key="0">
        全部
      </v-tab>
      <v-tab key="1">
        六A
      </v-tab>
      <v-tab key="2">
        九總-賀丞交
      </v-tab>
      <v-tab key="3">
        九總-嘉好
      </v-tab>
      <v-tab key="4">
        九總-上勇
      </v-tab>
      <v-tab key="5">
        九總-國祥
      </v-tab>
      <v-tab key="6">
        九總-聖錩
      </v-tab>
      <v-tab key="7">
        九總-鈔錢佈數
      </v-tab>
      <v-tab key="8">
        九總-嘉昌賀
      </v-tab>
      <v-tab key="9">
        電銷部
      </v-tab>
    </v-tabs>
    <v-card class="m-2">
      <v-card-text v-if="department !== '0'">
        <v-layout column wrap v-if="isAdmin || isAccounting || canEditCompanyDoc">
          <v-flex>
            <div class="table_wrapper">
              <table cellpadding="13"  border='1'>
                <thead>
                <tr>
                  <td>
                    <span class="title">項目</span>
                  </td>
                  <td v-for="(item,i) of balanceInfoByMonth" :key="i">
                    <span class="title">{{ i+1 }} 月</span>
                  </td>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <span class="title">收入</span>
                  </td>
                  <td v-for="(item,i) of balanceInfoByMonth" :key="i">
                    <span class="subheading">{{ item.incomePriceByDate }}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="title">零用金</span>
                  </td>
                  <td v-for="(item,i) of balanceInfoByMonth" :key="i">
                    <span class="subheading">{{ item.outcomePrice1ByDate }}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="title">支出</span>
                  </td>
                  <td v-for="(item,i) of balanceInfoByMonth" :key="i">
                    <span class="subheading">{{ item.outcomePrice2ByDate }}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="title">盈餘</span>
                  </td>
                  <td v-for="(item,i) of balanceInfoByMonth" :key="i">
                    <span class="subheading">{{ item.balance }}</span>
                  </td>
                </tr>
                </tbody>

              </table>
            </div>

<!--            <v-layout row>-->
<!--              <v-flex md4>-->
<!--                <span class="title">當月-零用金: {{ balanceInfo.outPrice1 ? balanceInfo.outPrice1 : 0 }}</span>-->
<!--              </v-flex>-->
<!--              <v-flex md4>-->
<!--                <span class="title">總支出: {{ balanceInfo.outPrice2 ? balanceInfo.outPrice2 : 0 }}</span>-->
<!--              </v-flex>-->
<!--              <v-flex md4>-->
<!--                <span class="title">總收入: {{ balanceInfo.inPrice ? balanceInfo.inPrice : 0 }}</span>-->
<!--              </v-flex>-->
<!--            </v-layout>-->
          </v-flex>
        </v-layout>
<!--        <br/>-->
<!--        <hr>-->
<!--        <br/>-->
<!--        <v-layout column wrap v-if="isAdmin || isAccounting">-->
<!--          <v-flex xs12 md12>-->
<!--            <v-layout row>-->
<!--              <v-flex md4>-->
<!--                <span class="title">區間-零用金: {{ balanceInfoByDate.outcomePrice1ByDate ? balanceInfoByDate.outcomePrice1ByDate : 0 }}</span>-->
<!--              </v-flex>-->
<!--              <v-flex md4>-->
<!--                <span class="title">總支出: {{ balanceInfoByDate.incomePriceByDate ? balanceInfoByDate.incomePriceByDate : 0 }}</span>-->
<!--              </v-flex>-->
<!--              <v-flex md4>-->
<!--                <span class="title">總收入: {{ balanceInfoByDate.outcomePrice2ByDate ? balanceInfoByDate.outcomePrice2ByDate : 0 }}</span>-->
<!--              </v-flex>-->
<!--            </v-layout>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
      </v-card-text>
    </v-card>
    <v-layout row wrap>
      <v-flex xs2 md2 >
        <v-btn color="primary" dark text  @click="showEditDialog(true)">新增</v-btn>
      </v-flex>
      <v-flex xs2 md2>
        <v-btn color="success" @click="exportData">匯出</v-btn>
      </v-flex>

      <v-flex xs2 md2>
        <v-btn color="primary" @click="$router.push('CompanyReportChart')">年度報表</v-btn>
      </v-flex>
    </v-layout>
    <v-layout  mt-2>
      <v-flex xs5 sm5 md5>
        <date-picker :date.sync="startDate" />
      </v-flex>
      <v-flex xs5 sm5 md5>
        <date-picker :date.sync="endDate" />
      </v-flex>
    </v-layout>
    <v-layout xs12>
      <v-flex md2 xs8>
        <v-select :items="getSearchKeys"
                  item-text="value"
                  item-value="key"
                  v-model="search.searchKey"
                  label="查詢條件"
        ></v-select>
      </v-flex>
      <v-flex md2 xs8 v-if="search.searchKey === 'category'">
        <v-select :items="categoryList"
                  v-model="search.keyword"
                  label="類型"
        ></v-select>
      </v-flex>
      <v-flex md2 xs8 v-if="search.searchKey === 'accountType'">
        <v-select :items="getAccountTypeList"
                  v-model="search.keyword"
                  label="會計科目"
        ></v-select>
      </v-flex>
      <v-flex ml-2 md4 xs8 v-if="search.searchKey === 'docId'">
        <v-text-field v-model="search.keyword" :label="`搜尋名稱或類型`" :placeholder="search.placeholder"
                      @keyup.enter="searchEvent"></v-text-field>
      </v-flex>
      <v-flex md4 xs4>
        <v-btn color="success" @click="searchEvent">搜尋</v-btn>
        <v-btn color="warning" @click="reset">重置</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap mt-2>
      <v-container
        fluid>
        <table-view :columnKeys="columnKeys"
                    :items="items"
                    :loading="loading"
                    :total-items="totalItems"
                    @cellEvent="cellEvent"
                    @changePage="changePage"
                    @handleLoadData="reset">
        </table-view>
      </v-container>
    </v-layout>


    <!--彈出視窗-->
    <alert-view :visible="messageDialog.visible"
                :title="messageDialog.title"
                :content="messageDialog.text"
                :isHtmlContent="true"
                :showCancel="messageDialog.showCancelButton"
                @cancelEvent="messageDialog.cancel"
                @confirmEvent="messageDialog.confirm"></alert-view>

    <company-doc-dialog :visible="fileDialog.visible"
                      :tags="categoryList"
                      :title="fileDialog.title"
                      :item="fileDialog.item"
                      :isNew="fileDialog.isNew"
                      @confirmEvent="fileDialogConfirm"
                        @deleteFileEvent="deleteFileDialogEvent"
                      @cancelEvent="fileDialog.cancel"
                      @deleteEvent="deleteInfo"></company-doc-dialog>
  </v-container>
</template>

<script>
import AlertView from '@/components/AlertView';
import TableView from '@/components/TableView';
import { mapActions, mapGetters } from 'vuex';
import CompanyDocDialog from '@/components/CompanyDocDialog';
import DatePicker from "@/components/DatePicker";
import common from '@/mixins/common';
import { getUUId, customFormatDate, exportFileToBlobUrl } from '@/pages/utils/tool';
import CompanyDocModel from '@/models/CompanyDocModel';
export default {
  name: 'CompanyDocList',
  mixins: [common],
  components: {
    CompanyDocDialog,
    AlertView,
    TableView,
    DatePicker
  },
  data() {
    return {
      department: '0',
      departmentList: ['全部', '六A','九總-賀丞交', '九總-嘉好', '九總-上勇', '九總-國祥', '九總-聖錩', '九總-鈔錢佈數', '九總-嘉昌賀','電銷部'],
      item: {
        projectId: '',
        name: '',
        sort: '',
      },
      tab: 0,
      loading: false,
      pageIndex: 1,
      limit: 50,
      totalItems: 0,
      typeStatus:0,
      saveLoading: false,
      search: {
        keyword: "",
        searchKey:'docId',
      },
      items: [],
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        showCancelButton: false,
        confirm: () => {},
        cancel: () => {},
      },
      fileDialog:{
        title: "",
        visible: false,
        loading: false,
        isNew:false,
        item: new CompanyDocModel(),
        confirm: () => {},
        cancel: () => {},
      },
      stockListDialog:{
        title:"",
        visible:false,
        type:0,
        items:[],
        confirm: () => {},
        cancel: () => {},
      },
      products: [],
      categoryList: ['零用金', '獎金申請', '收入款項', '支出費用'],
      selectItem: '',
      selectFileList: [],
      category: 'fileType',
      startDate: "",
      endDate: "",
      balanceInfo:{
        categoryA: 0,
        categoryAOut: 0,
        categoryB: 0,
        categoryBOut: 0,
        category9: 0,
        category9Out: 0,
      },
      balanceInfoByDate: {
        categoryAByDate: 0,
        categoryAOutByDate: 0,
        categoryBByDate: 0,
        categoryBOutByDate: 0,
        category9ByDate: 0,
        category9OutByDate: 0,
      },
      incomeInfo:{
        income6A: 0,
        income6AIn: 0,
        income6B: 0,
        income6BIn: 0,
        income9: 0,
        income9In: 0
      },
      incomeInfoByDate:{
        income6AByDate: 0,
        income6AInByDate: 0,
        income6BByDate: 0,
        income6BInByDate: 0,
        income9ByDate: 0,
        income9InByDate: 0
      },
      balanceInfoByMonth: [],
    };
  },
  created() {
    this.setDefaultDate();
    this.loadData();
    this.fetchAgentList();
  },
  watch:{
    department(value){
      console.log(`department ${value}`);
      this.loadData();
    },
  },
  computed: {
    ...mapGetters(["getUserInfo", "getAgentList"]),
    getAccountTypeList(){
      return [
        "客戶應收-上勇",
        "客戶應收-國祥",
        "客戶應收-聖錩",
        "客戶應收-鈔錢佈數",
        "客戶應收-賀丞交",
        "客戶應收-嘉昌賀",
        "其他費用-房租",
        "廠商應付-嘉好",
        "廠商應付-上勇",
        "廠商應付-國祥",
        "廠商應付-聖錩",
        "廠商應付-鈔錢佈數",
        "廠商應付-賀丞交",
        "廠商應付-嘉昌賀",
        "人事費-員工薪資",
        "人事費-臨時工資",
        "人事費-其他加給",
        "人事費-加班值班費",
        "人事費-獎金",
        "人事費-員工保險費",
        "人事費-員工退休退職金",
        "人事費-伙食津貼",
        "人事費-職工福利",
        "人事費-其他人事費用",
        "事務費-文具用品",
        "事務費-印刷及裝訂費",
        "事務費-書報雜誌",
        "事務費-電腦使用費",
        "事務費-水電費",
        "事務費-郵電費",
        "事務費-租金支出",
        "事務費-專業服務費",
        "事務費-廣告費",
        "事務費-訓練費",
        "事務費-其他事務費",
        "旅運費-交通費",
        "旅運費-住宿費",
        "旅運費-膳雜費",
        "旅運費-油費",
        "旅運費-搬運費",
        "旅運費-車馬補助費",
        "旅運費-其他旅運費",
        "財產使用費-雜項購置",
        "財產使用費-維修費",
        "財產使用費-管理清潔費",
        "財產使用費-財產保險費",
        "財產使用費-折舊費用",
        "財產使用費-各項攤銷",
        "財產使用費-稅捐及規費",
        "財產使用費-其他財產使用費",
        "活動費-會議費",
        "活動費-稿費",
        "活動費-聯誼活動費",
        "活動費-業務推廣費",
        "活動費-展覽費",
        "活動費-考察觀摩費",
        "活動費-刊物編輯費",
        "活動費-調查統計費",
        "活動費-研究發展費",
        "活動費-獎學金",
        "活動費-捐贈支出",
        "活動費-補助支出",
        "活動費-其他活動費",
        "其他費用-呆帳",
        "其他費用-雜項支出",
        "其他費用-嘉好購票",
        "其他費用-上勇購票",
        "其他費用-國祥購票",
        "其他費用-聖錩購票",
        "其他費用-鈔錢佈數購票",
        "其他費用-賀丞交購票",
        "其他費用-嘉昌賀購票",
        "其他費用-房貸",
        "其他費用-火險"
      ]
    },
    getSearchKeys(){
      return [
        { key:'docId', value: '編號' },
        { key:'category', value: '類型' },
        { key:'accountType', value: '會計科目' },
      ]
    },
    columnKeys() {
      const list = [
        { value: "edit", text: "編輯", sortable: false, required: false, color: 'primary', isEvent: true },
        { value: "print", text: "列印", sortable: false, required: false, color: 'primary', isEvent: true },
        { value: "docId", text: "編號", sortable: true, required: false },
        {
          value: "category",
          text: "類型",
          sortable: true,
          required: false,
        },
        {
          value: "department",
          text: "部門",
          sortable: true,
          required: false,
        },
        {
          value: "accountType",
          text: "會計科目",
          sortable: true,
          required: false,
        },
        {
          value: "invoiceType",
          text: "票據類型",
          sortable: true,
          required: false,
        },
        {
          value: "vendor",
          text: "廠商/客戶",
          sortable: true,
          required: false,
        },
        {
          value: "applicant",
          text: "領受人",
          sortable: true,
          required: false,
        },
        {
          value: "parentAgentId",
          text: "經辦人",
          sortable: true,
          required: false,
          options: this.getAgents(),
          isSelectText: true,
        },
        { value: "expectedAmount", text: "預期金額", sortable: true, required: false, isEvent: false },
        { value: "amount", text: "實收金額", sortable: true, required: false, isEvent: false },
        // { value: "comment", text: "備註", sortable: true, required: false },

        { value: "applyDate", text: "申請日期", sortable: true, required: false },
        { value: "createdDate", text: "建立時間", sortable: true, required: false }];
      return list
    },
  },
  methods: {
    ...mapActions(['uploadImageData', 'saveDocInfo', 'getDocList', 'updateDocInfo', 'deleteDocInfo', 'fetchAgentList']),
    getAgents(){
      const list = [];
      for (let agent of this.getAgentList){
        list.push({ key: agent.agentId, text: agent.displayName });
      }
      return list;
    },
    setDefaultDate() {
      let todayDate = new Date();
      todayDate.setMonth(todayDate.getMonth() - 1);
      let currentDate = todayDate.toISOString().substr(0, 10);
      const [thisYear, thisMonth, thisDay] = currentDate.split("-");
      this.startDate = `${thisYear}-${thisMonth}-01`;

      let futureDate = new Date();
      // 将当前月份加1，下移到下个月
      futureDate.setMonth(futureDate.getMonth() + 1);
      // 再获取天数即取上个月的最后一天的天数
      futureDate.setDate(0);
      let days = futureDate.getDate();

      let endDate = futureDate.toISOString().substr(0, 10);
      const [futureYear, futureMonth, futureDay] = endDate.split("-");

      this.endDate = `${futureYear}-${futureMonth}-${days}`;
    },
    showFileInfo(url){
      window.open(url, '_blank')
    },
    searchEvent(){
      this.loadData();
    },
    async exportData(){
      let query = [];
      if (this.search.keyword !== ''){
        query.push({ key: this.search.searchKey, value: this.search.keyword })
      }

      if (this.department !== '0' && this.department !== 0){
        query.push({ key: 'department', value: this.departmentList[this.department] })
      }

      const results = await this.getDocList({
        searchQuery: query,
        pageIndex: 1,
        limit: 10000,
        startDate: this.startDate,
        endDate: this.endDate,
        agentId: this.getUserInfo.agentId,
      });

      let columns = [];
      const list = [
        { text: '編號', value: 'docId'},
        { text: '類型', value: 'category'},
        { text: '部門', value: 'department'},
        { text: '會計科目', value: 'accountType'},
        { text: '票據類型', value: 'invoiceType'},
        { text: '廠商/客戶', value: 'vendor'},
        { text: '預期金額', value: 'expectedAmount'},
        { text: '實收金額', value: 'amount'}
      ];
      list.forEach((info) => {
        const itemInfo = {
          name: info.text,
          key: info.value,
        };
        columns.push(itemInfo);
      });
      const resultList = results.data.data.list;
      exportFileToBlobUrl("獎金、支出、收入證明單匯出", columns, resultList);
    },
    async loadData(){
      this.loading = true;

      let query = [];
      if (this.search.keyword !== ''){
        query.push({ key: this.search.searchKey, value: this.search.keyword })
      }

      if (this.department !== '0' && this.department !== 0){
        query.push({ key: 'department', value: this.departmentList[this.department] })
      }

      const res = await this.getDocList({
        searchQuery: query,
        pageIndex: this.pageIndex,
        limit: this.limit,
        startDate: this.startDate,
        endDate: this.endDate,
        agentId: this.getUserInfo.agentId,
      });

      this.loading = false;
      const result = res.data;
      this.items = result.data.list;
      this.totalItems = result.data.header.totalCount;
      this.balanceInfoByMonth = result.data.header.balanceInfoByMonth
      // this.balanceInfo = result.data.header.balanceInfo;
      // this.balanceInfoByDate = result.data.header.balanceInfoByDate;
      // this.incomeInfo = result.data.header.incomeInfo;
      // this.incomeInfoByDate = result.data.header.incomeInfoByDate;
      console.log(`balanceInfo = ${JSON.stringify(this.balanceInfo)}`);
    },
    cellEvent(props) { // cell 按鈕事件 (用Key判斷是點選哪一個
      console.log(`cellEvent ${JSON.stringify(props)}`)
      if (props.key === 'edit'){
        this.showEditDialog(false, props.item)
      } else if (props.key === 'print'){
        const url = `https://haorich.tw/#/CompanyDocView?docId=${props.item.docId}`;
        this.openURL(url);
      } else {
        this.copyURL(props.item.url);
      }
    },
    openURL(url) {
      window.open(url, '_bank');
    },
    copyURL(url) {
      const input = document.createElement('input');
      input.setAttribute('value', url);
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.showMessageDialog('提示','網址已複製！', true);
    },
    async uploadEvent(item, files){
      this.fileDialog.loading = true;
      if (this.fileDialog.isNew === false && (!files || files.length === 0)){
        this.updateDoc(item);
        this.fileDialog.loading = false;
        this.fileDialog.visible = false;
        return;
      }

      if (!this.isAccounting && !this.canEditCompanyDoc){
        if (this.fileDialog.isNew && files.length === 0){
          this.showMessageDialog('提示', '請選擇要上傳的檔案！', true);
          this.fileDialog.loading = false;
          return;
        }
      }

      this.fileDialog.loading = true;
      let i = 1;
      for (let file of files){
        const dataURL = await this.readFileAsync(file);
        const fileURL = await this.uploadData(file.name, item, dataURL);
        if (i < 5){
          if (item[`imageURL${i}`] && item[`imageURL${i}`] !==''){
            let index = i+1;
            if (index >= 5){
              index=1;
            }
            item[`imageURL${index}`] = fileURL;
          } else {
            item[`imageURL${i}`] = fileURL;
          }
        }
        i++;
      }
      console.log(`upload item ${JSON.stringify(item)}`);

      if (this.fileDialog.isNew && item.category === '零用金'){
        if (this.fileDialog.isNew){
          await this.addDoc(item)
        } else {
          await this.updateDoc(item)
        }
      } else {

        if (this.fileDialog.isNew){
          await this.addDoc(item)
        } else {
          await this.updateDoc(item)
        }
      }
    },
    readFileAsync(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
    },
    async uploadData(name, item, fileData) {
      try {
        const response = await this.$store.dispatch('uploadImageData', {
          name: `fileList/${name}`,
          image: fileData,
        });
        console.log(`upload Data success ${JSON.stringify(response)}`);
        return response;
        // 處理完成更新資料
      } catch (error) {
        console.error('Error uploading data:', error);
        return null;
      }
    },
    // uploadData(name, item, fileData){
    //   this.$store.dispatch('uploadImageData', {
    //     name: `fileList/${name}`,
    //     image: fileData,
    //   }).then((response) => {
    //     console.log(`upload Data success ${JSON.stringify(response)}`);
    //     // 處理完成更新資料
    //     item.imageURL1 = response;
    //
    //     if (this.fileDialog.isNew){
    //       this.addDoc(item)
    //     } else {
    //       this.updateDoc(item)
    //     }
    //   });
    // },
    async addDoc(item){
      try {
        const res = await this.saveDocInfo(item);
        const result = res.data;
        console.log(`result ${JSON.stringify(result)}`);

        if (result.statusCode === 0 ){
          this.resetInfo();
          this.showMessageDialog('提示', result.message, true);
          this.fileDialog.visible = false;
        } else {
          this.showMessageDialog('錯誤', result.message, true);
        }
      } catch (e) {
        this.showMessageDialog('錯誤', '發生異常，請輸入格式是否正確', true);
      } finally {
        this.fileDialog.loading = false;
      }
    },
    async updateDoc(item){
      try {
        const res = await this.updateDocInfo(item);
        const result = res.data;
        console.log(`result ${JSON.stringify(result)}`);

        if (result.statusCode === 0 ){
          this.resetInfo();
          this.showMessageDialog('提示', result.message, true);
          this.fileDialog.visible = false;
        } else {
          this.showMessageDialog('錯誤', result.message, true);
        }
      } catch (e) {
        this.showMessageDialog('錯誤', '發生異常，請輸入格式是否正確', true);
      } finally {
        this.fileDialog.loading = false;
      }
    },
    changePage(page) { // 改變頁數 or 每頁筆數
      this.pageIndex = page.page;
      this.limit = page.rowsPerPage;
      this.loadData();
    },
    resetInfo(){
      this.fileDialog.visible = false;
      this.fileDialog.item = new CompanyDocModel();
      this.loadData();
    },
    reset(){
      this.loadData();
    },
    showEditDialog(isNew , item){
      this.fileDialog.visible = true;
      this.fileDialog.isNew = isNew;
      this.fileDialog.title = isNew ? '新增':'編輯';
      if (item){
        this.fileDialog.item = item;
      } else {
        const model = new CompanyDocModel();
        model.docId = `${customFormatDate(new Date(), 'YYYYMMDDHHmmss')}`;
        this.fileDialog.item = model;
      }
      this.fileDialog.cancel = ()=>{
        this.resetInfo();
        this.fileDialog.visible = false;
      }
    },
    fileDialogConfirm(data){
      const { item, files } = data;
      this.fileDialog.loading = true;
      this.uploadEvent(item, files);
    },
    deleteFileDialogEvent(index){
      this.item[`imageURL${index}`] = null
    },
    async deleteInfo(docId){
      console.log(`delete = ${docId}`);
      const res = await this.deleteDocInfo({
        docId: docId,
      });
      const result = res.data;
      console.log(`result ${JSON.stringify(result)}`);
      if (result.statusCode === 0 ){
        this.resetInfo();
        this.showMessageDialog('提示', result.message, true);
      } else {
        this.showMessageDialog('錯誤', result.message, true);
      }
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
  }
};
</script>

<style scoped>
.table_wrapper{
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/web/CompanyDocList.vue